
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

export function SubscriptionsHeader() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Manage Your Subscriptions</CardTitle>
        <CardDescription>
          View and manage all your bin washing subscriptions in one place
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <p className="text-sm text-muted-foreground">
            Manage your active and past subscriptions below.
          </p>
          <Button asChild>
            <a href="/subscriptions">
              <Plus className="h-4 w-4 mr-2" />
              Add New Subscription
            </a>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
